import React from "react";
import chevronDown from "./figma/chevron-down.svg";

// Figma design-system chevron (node 38:137). MUI's Select applies the
// MuiSelect-icon / MuiSelect-iconOpen classes for positioning + rotation.
const PrimaryArrowIcon = (props: any) => {
  return (
    <img
      src={chevronDown}
      alt=""
      className={props.className}
      style={{
        width: 12,
        height: 7,
        top: "calc(50% - 3.5px)",
        transition: "transform 0.3s ease",
        pointerEvents: "none",
      }}
    />
  );
};

export default PrimaryArrowIcon;
